module.exports = __webpack_public_path__ + "static/media/thearqive_white_color_logos.edc13072.png";